import React, { createContext, useState, useContext } from "react";

const SignupContext = createContext();

export const SignupProvider = ({ children }) => {
  const [completedSteps, setCompletedSteps] = useState({
    personalInfo: false,
    signUp: false,
    verification: false,
  });

  return (
    <SignupContext.Provider value={{ completedSteps, setCompletedSteps }}>
      {children}
    </SignupContext.Provider>
  );
};

export const useSignup = () => useContext(SignupContext);
